module.exports = __webpack_public_path__ + "img/SHAPE.508121ad.svg";